import { useState } from "react";
import Atomic from "../../../AComponent/Atomic";
import { WorkflowProcesser } from "../Dimension/WorkflowProcesser";
import { getUserId, submitPayload } from "../../../Utils/Common/Library";
import ActionDebouncer from "../Dimension/ActionDebouncer";
import { Stack } from "@mui/material";
import EwModal from "../../../MComponent/Modal/Modal";

const { Button } = Atomic;

const AppraiseeActions = ({ FinalAssessments }) => {
  const [modal, setModal] = useState(null);
  const [buttonLoading, setButtonLoading] = useState(false);

  const assessments = Object.values(FinalAssessments)
    .filter(Boolean)
    .map((fa) => fa.find((a) => a.Workflow.WorkflowStatus !== "C"))
    .filter(Boolean);

  const getCondition = () => {
    if (assessments.length === 0) return null;
    const workflow = assessments[0].Workflow;
    if (!workflow) return null;
    const processor = new WorkflowProcesser(workflow);
    const steps = workflow.WorkflowSteps;
    const isModeratorDone = steps.find(
      (s) => s.StepOwnerLabel === "Moderator" && s.StepType === "Actioned"
    )
      ? true
      : false;
    if (isModeratorDone) {
      const pendingStep = processor.getCurrentStepData();
      if (
        pendingStep &&
        pendingStep.StepOwnerLabel === "Appraisee" &&
        pendingStep.StepOwnerUserIDs[0] === getUserId()
      )
        return pendingStep;
    }
    return null;
  };

  const appraiseeStep = getCondition();

  if (!appraiseeStep) return <></>;

  function submitDimensionWorkflow(ParameterAssessment, ActionType) {
    const Header = ParameterAssessment.Header;
    const Data = ParameterAssessment.Data;
    const Workflow = ParameterAssessment.Workflow;

    const workflowProcesser = new WorkflowProcesser(Workflow);
    let stepId = workflowProcesser.getCurrentStepID();

    const WorkflowID = Workflow.WorkflowID;

    let obj = {
      stepId,
      action: ActionType,
      WorkflowID,
    };

    let edit = {
      TransactionID: Header.TransactionID,
      EffectiveFromTimestamp: Header.EffectiveFromTimestamp,
    };

    return submitPayload({
      featureId: "19152",
      payload: Data,
      updateAction: obj,
      edit,
    });
  }

  function delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async function onSubmit(ActionType) {
    setButtonLoading(true);
    for (let i = 0; i < assessments.length; i++) {
      await submitDimensionWorkflow(assessments[i], ActionType);
      if (i < assessments.length - 1) {
        await delay(3000);
      }
    }
    setModal({
      Component: ActionDebouncer,
      dontClose: true,
      props: {
        navigate: true,
        navigatePath: "/myplan",
      },
    });
    setButtonLoading(false);
  }

  return (
    <Stack alignItems={"flex-start"}>
      {appraiseeStep && (
        <Button
          label={appraiseeStep.AllowedActions[0]}
          isLoading={buttonLoading}
          size="small"
          onClick={() => {
            onSubmit(appraiseeStep.AllowedActions[0]);
          }}
          style={{ margin: 0 }}
        />
      )}
      {modal && (
        <EwModal
          onClose={() => {
            !modal.dontClose && setModal(null);
          }}
          open={modal}
        >
          <modal.Component {...modal.props} />
        </EwModal>
      )}
    </Stack>
  );
};

export default AppraiseeActions;
